import "./CardsProfsActifs.css";
import React from "react";
import ListGroup from 'react-bootstrap/ListGroup';
import avatar from "../../Assets/avatar.png"
import { BiDotsVerticalRounded } from 'react-icons/bi'
import { MdDeleteOutline } from 'react-icons/md'
import { FaRegEdit } from 'react-icons/fa'
import {Dropdown } from "react-bootstrap";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Crud from "../Crud/Crud";


function template({ domaine, prenom , nom ,isArchived,id,photo}) {
  const elt_collection ='users'
  const myphotos = photo !== undefined? photo : avatar;
  return (
    <div id="cardsProfsActifs" className="py-2 px-3">
          <ListGroup.Item className="d-flex justify-content-between">
            <div className=" d-flex">
              <div>
                <img src={myphotos} alt={"images"} className="imgCPA" />
              </div>
              <div className="ps-3">
                <h6 className="fw-blod">{nom} {prenom}</h6>
                <p className="small">{domaine}</p>
              </div>
            </div>
            <Crud
             isArchived={isArchived}
             elt_collection={elt_collection}
             id={id}
            />
          </ListGroup.Item> 
    </div>
  );
}

export default template;
